import { render, staticRenderFns } from "./page-agv-comparison.vue?vue&type=template&id=1200702a&scoped=true&lang=pug&"
import script from "./page-agv-comparison.vue?vue&type=script&lang=js&"
export * from "./page-agv-comparison.vue?vue&type=script&lang=js&"
import style0 from "./page-agv-comparison.vue?vue&type=style&index=0&id=1200702a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200702a",
  null
  
)

export default component.exports